import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H4, Paragraph } from 'components/core/Typography';
import { ModalLink } from 'components/core/ModalLink';
import FacilityFeeItem from './FacilityFeeItem';

import './facilityFees.scss';

export function FacilityFees({
	className, adminFee, deposit = {}, insurance
}) {
	const list = [];

	if (adminFee) {
		const ModalLinkContent = (
			<div className="modal-link-content">
				<H4 size="medium">
					Facility administration fee
				</H4>
				<Paragraph>
					Standard fee charged to all new tenants. This fee will be paid upon move-in.
				</Paragraph>
			</div>
		);

		const text = (
			<span className="admin-fee">
				{adminFee.text || 'None'}
			</span>
		);

		list.push(
			<FacilityFeeItem
				fee="Facility administration fee"
				value={text}
				key="admin-fee"
			/>
		);

		list.push(
			<li key="admin-fee-modal-link">
				<ModalLink
					text={(<span className="long-text">What are facility fees?</span>)}
					content={ModalLinkContent}
					size="standard"
					hideIcon
				/>
			</li>
		);
	}

	if (deposit.hasDeposit) {
		const depositTraits = [];
		if (deposit.isRefundable) {
			depositTraits.push('Refundable');
		}

		if (deposit.value) {
			depositTraits.push(deposit.text);
		} else if (deposit.percent) {
			depositTraits.push(`${deposit.percent * 100}% of first month's rent`);
		} else {
			depositTraits.push('percentage of first month\'s rent');
		}

		list.push(
			<FacilityFeeItem
				fee="Security deposit"
				value={depositTraits.join(', ')}
				key="deposit"
			/>
		);
	}

	if (insurance) {
		list.push(
			<FacilityFeeItem
				fee="Insurance"
				value="Required"
				key="insurance"
			/>
		);
	}

	if (!list.length) {
		return null;
	}

	return (
		<div className={classnames(className, 'facility-fees')}>
			<H4 size="medium" className="facility-fees-list-header">
				Facility's fees & requirements
			</H4>
			<ul className="fees-list">
				{list}
			</ul>

		</div>
	);
}

FacilityFees.propTypes = {
	className: PropTypes.string,
	adminFee: PropTypes.shape({
		value: PropTypes.number.isRequired,
		text: PropTypes.string.isRequired
	}),
	deposit: PropTypes.shape({
		value: PropTypes.number,
		text: PropTypes.string,
		percent: PropTypes.number,
		isRefundable: PropTypes.bool,
		hasDeposit: PropTypes.bool
	}),
	insurance: PropTypes.bool
};

export default FacilityFees;
